/**
* Body Classes Directive
* @todo make this a class
*/

function bodyClasses($rootScope) {
    return {
        restrict: 'A',
        scope: {},
        link: function (scope, elem, attr, ctrl) {
            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var fromClassnames = angular.isDefined(fromState.params) && angular.isDefined(fromState.params.bodyClasses) ? fromState.params.bodyClasses : null;
                var toClassnames = angular.isDefined(toState.params) && angular.isDefined(toState.params.bodyClasses) ? toState.params.bodyClasses : null;

                // don't do anything if they are the same
                if (fromClassnames != toClassnames) {
                    if (fromClassnames) {
                        elem.removeClass(fromClassnames);
                    }

                    if (toClassnames) {
                        elem.addClass(toClassnames);
                    }
                }
            });
        }
    };
}

export default angular.module('bodyClasses', []).directive('bodyClasses', ['$rootScope',bodyClasses]).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/bodyClasses.directive.js
 **/